import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type Tone = "neutral" | "accent" | "success" | "warning" | "danger" | "info";

interface BadgeProps {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}

const TONES: Record<Tone, string> = {
  neutral: "bg-white/5 text-bridge-muted border-bridge-border/70",
  accent: "bg-[#009BF5]/10 text-[#009BF5] border-[#009BF5]/30",
  success: "bg-bridge-success/10 text-bridge-success border-bridge-success/30",
  warning: "bg-bridge-warning/10 text-bridge-warning border-bridge-warning/30",
  danger: "bg-bridge-danger/10 text-bridge-danger border-bridge-danger/30",
  info: "bg-bridge-info/10 text-bridge-info border-bridge-info/30",
};

export function Badge({ tone = "neutral", children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2 h-6 text-[11px] font-medium uppercase tracking-wide rounded-xs border",
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}